export enum OfferType {
	Sale = 'kauf',
	Rent = 'miete',
}
